<template>
  <div class="add">
    <!--商品信息-->
    <form-info :formData="formData" :isEdit="false" :testData="testData"></form-info>
  </div>
</template>

<script>
import drawForm from "./audio-form";

export default {
  created() {
    //模拟异步触发draw-form组件的watch事件
    setTimeout(() => {
      this.formData = {
        course_mode: "2", //课程类型
        times:'',//副标题
        course_name: "", //课程名字
        started_at: "", //开始时间
        course_duration: 60, //时长
        course_cover: "", //课程封面图片
        ppt:[],
        course_resource_links:[],
        preview_link:'',
        publicity_cover: "", //课程宣传封面
        card_cover:'',//卡片的图
        teachers: [
          {
            teacher_name: "", //讲师名称列表
            teacher_title: "", //列表讲师标题
            teacher_introduction: "", //讲师简介列表
            teacher_pfrofile_photo: ""//讲师头像列表
          }
        ],
        course_outline: "", //课程提纲
        common_problem: "", //常见问题,
        // 子组件需要的内容
        is_try: false, //是否可以试听5分钟
        course_sell_price: "", //价格
        course_sell_mode: 2, //售卖方式
        state: 1, //上架设置
        published_at: "", //上架时间
        home_page_banner: true,
        topic_id: "" //单个关联的id
      };
    });
  },
  components: {
    "form-info": drawForm
  },
  data() {
    return {
      testData: {
        course_mode: "2",
        course_name: "7964464",
        started_at: "2019-08-09 17:57:10",
        course_duration: "60",
        course_resource_links:[
          "http://oss.zhidx.com/live/uploads/audio/2019/08/5d46e1fcb42061564926460.mp3"],
        course_cover:
          "http://oss.zhidx.com/live/uploads/images/2019/08/5d46e21d209961564926493.jpg",
        publicity_cover:
          "http://oss.zhidx.com/live/uploads/images/2019/08/5d46e224e65d81564926500.jpg",
        ppt: [
          "http://oss.zhidx.com/live/uploads/images/2019/08/5d46e20f8263a1564926479.jpg"
        ],
        teachers: [
          {
            teacher_name: "李四",
            teacher_title: "3535",
            teacher_introduction: "好的你好",
            teacher_pfrofile_photo:
              "http://oss.zhidx.com/live/uploads/images/2019/08/5d46e23bc0ace1564926523.jpg"
          }
        ],
        course_outline: "额",
        common_problem: "长",
         // 子组件需要的内容
        is_try: "0",
        course_sell_price: "22.22",
        course_sell_mode: 1,
        state: 1,
        published_at: "2019-08-10 17:59:02",
        home_page_banner: 1,
        topic_id: "6"
      },
      formData: {}
    };
  },
  methods: {
    //下架
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>